"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var React = require("react");
var Cooltip_1 = require("../Cooltip");
var Icon_1 = require("../Icon");
var ColumnHeader = (function (_super) {
    __extends(ColumnHeader, _super);
    function ColumnHeader(props) {
        var _this = _super.call(this, props) || this;
        _this.mouseOver = function () {
            var element = _this.refHeaderTitle;
            var hasOverflowingTitle = element.offsetHeight + 2 < element.scrollHeight ||
                element.offsetWidth + 2 < element.scrollWidth;
            if (_this.state.isActiveOverflow !== hasOverflowingTitle) {
                _this.setState({ isActiveOverflow: hasOverflowingTitle });
            }
        };
        _this.state = {
            isActiveOverflow: false
        };
        _this.handleHeaderClick = _this.handleHeaderClick.bind(_this);
        _this.handleRefHeaderTitle = _this.handleRefHeaderTitle.bind(_this);
        return _this;
    }
    ColumnHeader.prototype.handleHeaderClick = function (sortByFieldName) {
        if (this.props.headerClick) {
            this.props.headerClick(sortByFieldName);
        }
    };
    ColumnHeader.prototype.render = function () {
        var _this = this;
        //If a column has a header, and a sort function, it can be sorted. 
        var sortable = this.props.header !== undefined && this.props.headerClick !== undefined;
        var columnWidth = this.props.columnWidth && this.props.isFixed ? "col-md-" + this.props.columnWidth : '';
        var headerClasses = classNames({
            'sortable': sortable,
            'sorted': this.props.sort !== 'unsorted',
            'hide': this.props.isHidden,
            'text-nowrap': this.props.headerNowrap
        }, columnWidth);
        var chevron = this.props.sort !== 'unsorted' ?
            this.props.sort === 'asc' ?
                React.createElement(Icon_1.Icon, { icon: 'down' }) :
                React.createElement(Icon_1.Icon, { icon: 'up' })
            : '';
        var divClass = classNames({
            'display-flex': true,
            'th-inner': this.props.isFixed
        }, columnWidth);
        var headerTitle = this.props.header;
        if (this.props.isFixed) {
            headerTitle = (React.createElement(Cooltip_1.Cooltip, { tooltipType: 'default', tooltipContents: React.createElement("span", null, this.props.header), hidden: !this.state.isActiveOverflow, placement: 'topLeft' },
                React.createElement("div", { className: 'header-title-ellipsis', ref: this.handleRefHeaderTitle, onMouseOver: this.mouseOver }, this.props.header)));
        }
        return (
        // tslint:disable-next-line:jsx-no-lambda
        React.createElement("th", { className: headerClasses, onClick: function () { return _this.handleHeaderClick(_this.props.columnName); }, key: "col-head-" + (this.props.colIndex + 1) },
            React.createElement("div", { className: divClass },
                headerTitle,
                chevron)));
    };
    ColumnHeader.prototype.handleRefHeaderTitle = function (element) {
        this.refHeaderTitle = element;
    };
    return ColumnHeader;
}(React.Component));
exports.ColumnHeader = ColumnHeader;
//# sourceMappingURL=ColumnHeader.js.map